import { jsonrepair } from 'jsonrepair';
import passwordValidator from 'password-validator';

const schema = new passwordValidator();
schema
  .is()
  .min(8) // Minimum length 8
  .is()
  .max(100);

export const validatePassword = (password: string) => {
  const result = schema.validate(password);
  return result;
};

export const parseJson = (value: string): any => {
  if (!value) {
    return undefined;
  }
  if (typeof value !== 'string') {
    return value;
  }
  try {
    return JSON.parse(value);
  } catch (e) {
    try {
      const repaired = jsonrepair(value);
      return JSON.parse(repaired);
    } catch (e1) {
      return { value };
    }
  }
};

export const findNestedField = (obj: any, targetKeys: string[]): any => {
  if (!obj || typeof obj !== 'object') {
    return undefined;
  }

  for (const targetKey of targetKeys) {
    if (obj[targetKey]) {
      return obj[targetKey];
    }
    for (const key of Object.keys(obj)) {
      const result = findNestedField(obj[key], targetKeys);
      if (result !== undefined) {
        return result;
      }
    }
  }

  return undefined;
};

export const formatRunDuration = (start?: Date | string | null, end?: Date | string | null): string | null => {
  if (!start || !end) return null;
  const startMs = new Date(start).getTime();
  const endMs = new Date(end).getTime();
  if (isNaN(startMs) || isNaN(endMs) || endMs < startMs) return null;
  const diffMs = endMs - startMs;
  if (diffMs < 1000) return `${diffMs}ms`;
  if (diffMs < 60000) return `${(diffMs / 1000).toFixed(1)}s`;
  const mins = Math.floor(diffMs / 60000);
  const secs = Math.floor((diffMs % 60000) / 1000);
  return `${mins}m ${secs}s`;
};

export const eventNameEquals = (a?: string | null, b?: string | null): boolean => {
  if (a == null || b == null) {
    return a == b;
  }
  return a.toLowerCase() === b.toLowerCase();
};
